type LocalizedNameSource = {
	name?: string | null;
	localizedName?: string | null;
};

export const formatLocalizedName = (
	source: LocalizedNameSource | null | undefined
): string => {
	if (!source?.name) return '';

	const { name, localizedName } = source;

	if (!localizedName || localizedName === name) {
		return name;
	}

	return `${localizedName} (${name})`;
};
